import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import DropdownMenu from './DropdownMenu';

const UserAuthAvatar: React.FC = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  // Get user initials from metadata or email
  const getUserInitials = () => {
    if (!user) return '?';

    const metadata = user.user_metadata;

    // Try first name + last name first
    if (metadata?.first_name || metadata?.last_name) {
      const first = metadata?.first_name?.[0] || '';
      const last = metadata?.last_name?.[0] || '';
      return (first + last).toUpperCase() || '?';
    }

    // Fallback to email
    if (user.email) {
      const emailParts = user.email.split('@');
      return emailParts[0][0]?.toUpperCase() || '?';
    }

    return '?';
  };

  // Get display name
  const getDisplayName = () => {
    if (!user) return 'Unknown User';

    const metadata = user.user_metadata;

    if (metadata?.first_name && metadata?.last_name) {
      return `${metadata.first_name} ${metadata.last_name}`;
    }

    if (metadata?.first_name) {
      return metadata.first_name;
    }

    return user.email || 'Unknown User';
  };

  const menuActions = [
    {
      label: 'Profile',
      onClick: () => {
        navigate('/dashboard/settings');
      }
    },
    {
      label: 'Sign Out',
      onClick: () => {
        signOut();
      },
      color: 'text-red-600',
      hoverColor: 'hover:bg-red-50'
    }
  ];

  const hasAvatar = user?.user_metadata?.avatar_url;

  return (
    <DropdownMenu
      actions={menuActions}
      className="relative z-10"
      triggerClassName="flex items-center justify-center w-10 h-10 rounded-full overflow-hidden border-2 border-gray-200 bg-gray-100 hover:border-gray-300 transition-colors p-0"
    >
      {hasAvatar ? (
        <img
          src={user.user_metadata.avatar_url}
          alt={getDisplayName()}
          className="w-full h-full object-cover"
        />
      ) : (
        <span className="text-sm font-medium text-gray-600">
          {getUserInitials()}
        </span>
      )}
    </DropdownMenu>
  );
};

export default UserAuthAvatar;